import React, { useEffect, useState } from "react";
import CandidateExcelUpload from "../CandidateExcelUpload";
import AddNewCandidate from "../AddNewCandidate";
import CandidateErrorPopUp from "../CandidateErrorPopUp";
import EditCandidate from "../EditCandidate";
import ListDataCandidate from "../ListDataCandidate";
import LoadingWithLable from "../../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchCandidateList } from "../candidateListFunctions";

export default function UploadSelectionList({
  candidateListData,
  setCandidateListData,
  loading,
}) {
  const { projectId } = useParams();

  const [openCandidateUpload, setOpenCandidateUpload] = useState(false);
  const [openAddNewPopup, setOPenAddNewPopup] = useState(false);
  
  const [showErrorPopUp, setShowErrorPopUp] = useState();

  return (
    <>
      {openCandidateUpload && (
        <CandidateExcelUpload
          showPromptElement={openCandidateUpload}
          setShowPromptElement={setOpenCandidateUpload}
          setShowErrorPopUp={setShowErrorPopUp}
          setCandidateListData={setCandidateListData}
          type="candidate_selection_list"
        />
      )}
      {openAddNewPopup && (
        <AddNewCandidate
          showPromptElement={openAddNewPopup}
          setShowPromptElement={setOPenAddNewPopup}
          candidateListData={candidateListData}
          projectId={projectId}
          setCandidateListData={setCandidateListData}
        />
      )}
      {showErrorPopUp && (
        <CandidateErrorPopUp
          showErrorPopUp={showErrorPopUp}
          onToggle={() => setShowErrorPopUp(false)}
        />
      )}
      
      {loading ? (
        <LoadingWithLable />
      ) : (
        <ListDataCandidate
          setOpenCandidateUpload={setOpenCandidateUpload}
          setOPenAddNewPopup={setOPenAddNewPopup}
          candidateData={candidateListData}
          projectId={projectId}
          setCandidateListData={setCandidateListData}
        />
      )}
    </>
  );
}
